import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ApiService } from './api.service';
import { ApiResponse } from '../models/api-response';
import {
  ReconDraftStartResponse,
  ReconRunListResponse,
  ReconRunResponse,
} from '../models/reconciliation';

@Injectable({ providedIn: 'root' })
export class ReconciliationService {
  constructor(private api: ApiService) {}

  startReconciliation(statementId: string): Observable<ReconDraftStartResponse> {
    return this.api
      .post<ApiResponse<ReconDraftStartResponse>>(
        `/statements/${statementId}/recon/drafts`,
        {}
      )
      .pipe(
        map(res => {
          if (!res.data) {
            throw new Error(res.message || 'Reconciliation run did not return data');
          }
          return res.data;
        })
      );
  }

  listRuns(statementId: string): Observable<ReconRunListResponse> {
    return this.api
      .get<ApiResponse<ReconRunListResponse>>(`/statements/${statementId}/recon/runs`)
      .pipe(
        map(res => {
          if (!res.data) {
            throw new Error(res.message || 'Reconciliation runs did not return data');
          }
          return res.data;
        })
      );
  }

  getRun(statementId: string, runId: string): Observable<ReconRunResponse> {
    return this.api
      .get<ApiResponse<ReconRunResponse>>(`/statements/${statementId}/recon/runs/${runId}`)
      .pipe(
        map(res => {
          if (!res.data) {
            throw new Error(res.message || 'Reconciliation run did not return data');
          }
          return res.data;
        })
      );
  }

  getLatestRun(statementId: string): Observable<ReconRunResponse> {
    return this.api
      .get<ApiResponse<ReconRunResponse>>(`/statements/${statementId}/recon/runs/latest`)
      .pipe(
        map(res => {
          if (!res.data) {
            throw new Error(res.message || 'Latest reconciliation run did not return data');
          }
          return res.data;
        })
      );
  }
}
